import { REQUEST_SUCCESS } from "../../../middlewares/api/actions";
import { getCurrentNodeConfig } from "../../../middlewares/current-node-config/middleware";
import { getArtefactFromSdmxJsonStructure, getSdmxStructuresFromSdmxJson } from "../../../utils/sdmxJson";
import {
  UPDATE_DATABROWSER_DSD_CACHE_ANNOTATIONS_HIDE,
  UPDATE_DATABROWSER_DSD_CACHE_ANNOTATIONS_SHOW,
  UPDATE_DATABROWSER_DSD_CACHE_LIST_DSDS_READ
} from "./actions";

const updataDatabrowserDsdCacheReducer = (
  state = {
    dsds: null,
    dsdLayoutAnnotations: null,
    dsdAnnotationTriplet: null,
  },
  action
) => {
  switch (action.type) {
    case UPDATE_DATABROWSER_DSD_CACHE_ANNOTATIONS_SHOW:
      return {
        ...state,
        dsdLayoutAnnotations: action.annotations,
        dsdAnnotationTriplet: action.triplet
      };
    case UPDATE_DATABROWSER_DSD_CACHE_ANNOTATIONS_HIDE:
      return {
        ...state,
        dsdLayoutAnnotations: null,
        dsdAnnotationTriplet: null
      };

    case REQUEST_SUCCESS:
      switch (action.label) {
        case UPDATE_DATABROWSER_DSD_CACHE_LIST_DSDS_READ:
          return {
            ...state,
            dsds: getSdmxStructuresFromSdmxJson(action.response).map(artefact =>
              getArtefactFromSdmxJsonStructure(artefact, getCurrentNodeConfig(action).annotations))
          }
        default:
          return state;
      }

    default:
      return state;
  }

}
export default updataDatabrowserDsdCacheReducer;